import React, { useState } from "react";
import styled from "styled-components";
import { userTrack } from "../Common";
import RightArrow from "../images/menu-right.svg";
import ContainerBackGround from "./ContainerBackGround.svg";

const Topwraper = styled.div``;
const Outerwraper = styled.div`
  width: 700px;
  height: 511px;
  border-radius: 5px;
  background-image: url(${(props) => props.rightImg});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  @media screen and (max-width: 767px) {
    width: 62vw;
    height: 240px;
  }
`;
const Heading = styled.p`
  margin: 0;
  color: #000;
  letter-spacing: 1.2px;
  text-align: ${(props) => (props.temporaryhideImage ? "center" : "left")};
  width: 862px;
  font-family: Roboto;
  font-size: 40px;
  font-weight: 400;
  line-height: 52px;
  letter-spacing: 0.05em;
  text-align: center;

  @media screen and (max-width: 767px) {
    width: auto;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 35px;
    line-height: 51px;
  }
`;
const Headingwraper = styled.div`
  display: ${(props) => (props.temporaryhideImage ? "flex" : "")};
  align-items: ${(props) => (props.temporaryhideImage ? "center" : "")};
  flex-direction: ${(props) => (props.temporaryhideImage ? "column" : "")};
  @media screen and (max-width: 767px) {
    padding: 0 15px;
  }
`;
const Outerbox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-top: 100px;
  padding: 0 100px;
  background: url(${(props) => props.Img});
  height: ${(props) => (props.temporaryhideImage ? "300px" : "")};
    background-size: contain;
    background-repeat: no-repeat;

  @media screen and (min-width: 1517px) {
    padding: 0px 180px;
    gap: 16px;
    margin-top: 100px;
  }
  @media (min-width: 1524px) and (max-width: 1920px) {
    padding: 0px 290px;
    margin-top: 100px;
  }

  @media screen and (max-width: 767px) {
    flex-flow: column-reverse wrap;
    padding: 0px 10px;
    margin-top: 100px;
    flex-wrap: wrap;
    margin-top: 0px;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    height: 100%;
    padding-bottom: 40px;
    padding-top: 40px;
  }
`;
const Leftbox = styled.div``;
const LeftContent = styled.p`
  margin: 0;
  color: #4e4e4e;
  width: 862px;
  text-align: ${(props) => (props.temporaryhideImage ? "center" : "left")};
  margin-top: 13px;
  margin-bottom: 10px;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 300;
  line-height: 39px;
  text-align: center;

  @media screen and (max-width: 767px) {
    width: 338px;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 20px;
  }
`;
const Link = styled.a`
  color: #4b59dd;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  :hover {
    color: #15436d;
  }
`;
const Img = styled.img``;



export default function MapsTextImage(props) {
  const HandleLink = async () => {
    if (
      props.Heading ==
      "Setup listening posts to smartly monitor your industry dynamics"
    ) {
      await userTrack("", "Onclick of Link", "Homepage");
      window.location.href = "/Team/Corporate-Strategy.html";
    }
    if (
      props.Heading ==
      "Scouting isn't just about technologies anymore, it needs to be fused with market and trends data"
    ) {
      await userTrack("", "Onclick of Link", "Homepage");
      window.location.href = "/Team/R&D-and-Tech-Scouting.html";
    }
    if (props.Heading == "Creating winning proposals needs timely insights") {
      await userTrack("", "Onclick of Link", "Homepage");
      window.location.href = "/Team/Sales-and-Marketing.html";
    }
    if (
      props.Heading ==
      "Coming up with a thesis using deep technological analysis of startups"
    ) {
      await userTrack("", "Onclick of Link", "Homepage");
      window.location.href = "/Team/CVC-and-M&A.html";
    }
    if (props.Heading == "Zoom out, then zoom in") {
      await userTrack("", "Onclick of Link", "Homepage");
      window.location.href = "/Team/New-Business-Development.html";
    }
  };
  const [temporaryhideImage, setTemporaryhideImage] = useState(true);


  return (
    <div>
      <Outerbox
        temporaryhideImage={temporaryhideImage}
        Img={ContainerBackGround.src}
        alt={props.Heading}
      >
        <Headingwraper temporaryhideImage={temporaryhideImage}>
          <Heading temporaryhideImage={temporaryhideImage}>
            {props.Heading}
          </Heading>

          <Leftbox>
            <LeftContent temporaryhideImage={temporaryhideImage}>
              {props.Content}
            </LeftContent>
            {props.link && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <Link onClick={HandleLink}>{props.link}</Link>
                <Img src={RightArrow} style={{ cursor: "pointer" }}></Img>
              </div>
            )}
          </Leftbox>
        </Headingwraper>
        {!temporaryhideImage && (
          <Topwraper>
            <Outerwraper rightImg={props.rightImg}></Outerwraper>
          </Topwraper>
        )}
      </Outerbox>
    </div>
  );
}
